<template>
  <b-modal :id="modalId" centered @shown="shown" @hidden="hide"
           no-close-on-esc
           no-close-on-backdrop
           hide-header-close hide-header
           hide-footer>
    <Loader>
      <template #message>{{ $t('pages.checkout.modal_payment_processing_text') }}</template>
    </Loader>
  </b-modal>
</template>


<script>
import Loader from "@/components/Loader.vue"
import {mapActions} from "vuex";
import {payModes} from "@/domain/checkout/constants";

export default {
  components: {
    Loader,
  },

  props: {
    modalId: {
      type: String,
      required: true
    },
  },

  methods: {
    ...mapActions('cartDigitalItems', [
      'createOrder',
      'deleteCart',
      'emitFbPixelPurchaseEvent']),
    hide() {
      this.$bvModal.hide(this.modalId)
    },

    showAndPay() {
      this.$bvModal.show(this.modalId)
    },

    async shown() {
      await this.pay()
    },

    async pay() {
      this.isLoadingOrder = true
      const order = await this.createOrder({payment_method: payModes.BANK_TRANSFER})
      this.isLoadingOrder = false
      this.emitFbPixelPurchaseEvent({
        currency: order.currency,
        amount: order.price_grandtotal
      })
      await this.deleteCart()
      await this.$nextTick()
      this.emitPromised('order-success', order.id)
    }
  }
}
</script>
